// src/components/dashboard/DailyBreakdownV3.jsx — v8.8.1
//
// ПАТЧ по записке "добавить мини-иконки трендов":
// — Добавлена колонка Trend: ↑ ↓ → сравнение с предыдущим днём по ROI
// — ↑ зелёный (ROI вырос), ↓ красный (ROI упал), → серый (без изменений ±2pp)
// — Таблица теперь 5 колонок: Date / Spend / Revenue / ROI / Trend

import Panel        from "../ui/Panel";
import SectionTitle from "../ui/SectionTitle";

function fmtRoi(v) {
  if (v == null) return "—";
  let n = Number(v);
  if (!Number.isFinite(n)) return "—";
  if (Math.abs(n) < 10) n = n * 100;
  return `${n > 0 ? "+" : ""}${n.toFixed(1)}%`;
}

function toRoiPct(v) {
  if (v == null) return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  return Math.abs(n) < 10 ? n * 100 : n;
}

function roiColor(v) {
  if (v == null) return "var(--text-tertiary)";
  let n = Number(v);
  if (Math.abs(n) < 10) n = n * 100;
  if (n > 20)  return "rgba(16,217,126,0.85)";
  if (n > 0)   return "rgba(245,166,35,0.85)";
  return "rgba(240,64,64,0.85)";
}

function rowBg(v) {
  if (v == null) return "transparent";
  let n = Number(v);
  if (Math.abs(n) < 10) n = n * 100;
  if (n < -10) return "rgba(240,64,64,0.018)";
  if (n > 45)  return "rgba(16,217,126,0.015)";
  return "transparent";
}

// Трендовая стрелка относительно предыдущего дня
function TrendArrow({ current, previous }) {
  const cur = toRoiPct(current);
  const prv = toRoiPct(previous);
  if (cur == null || prv == null) return <span style={{ color: "var(--text-muted)" }}>—</span>;
  const delta = cur - prv;
  if (delta > 2)  return <span style={{ color: "var(--success)", fontWeight: 700, fontSize: 12 }}>↑</span>;
  if (delta < -2) return <span style={{ color: "var(--danger)",  fontWeight: 700, fontSize: 12 }}>↓</span>;
  return <span style={{ color: "var(--text-muted)", fontSize: 12 }}>→</span>;
}

export default function DailyBreakdownV3({ breakdown }) {
  const rows = Array.isArray(breakdown)
    ? breakdown.filter(r => Number(r.spend) > 0 || Number(r.revenue) > 0).slice(-16)
    : [];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <SectionTitle title="Daily Breakdown" />
      <Panel style={{ padding: 0, overflow: "hidden", flex: 1 }}>
        {rows.length === 0 ? (
          <div style={{ padding: "20px 16px", fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-muted)" }}>
            No data available
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  {["Date", "Spend", "Revenue", "ROI", ""].map((h, i) => (
                    <th key={i} style={{
                      padding: "8px 10px",
                      background: "var(--bg-tertiary)",
                      fontFamily: "var(--font-mono)", fontSize: 9,
                      letterSpacing: "0.14em", textTransform: "uppercase",
                      color: "var(--text-tertiary)", fontWeight: 400,
                      textAlign: i === 4 ? "center" : "left",
                      borderBottom: "1px solid var(--border-subtle)",
                      // Trend колонка — узкая
                      width: i === 4 ? 28 : "auto",
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={row.date ?? idx} style={{
                    borderBottom: "1px solid var(--border-subtle)",
                    background: rowBg(row.roi),
                  }}>
                    <td style={{ padding: "7px 10px", fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--text-secondary)" }}>
                      {row.date}
                    </td>
                    <td style={{ padding: "7px 10px", fontFamily: "var(--font-mono)", fontSize: 11, color: "rgba(240,64,64,0.85)" }}>
                      €{Number(row.spend).toFixed(0)}
                    </td>
                    <td style={{ padding: "7px 10px", fontFamily: "var(--font-mono)", fontSize: 11, color: "rgba(16,217,126,0.85)" }}>
                      €{Number(row.revenue).toFixed(0)}
                    </td>
                    <td style={{ padding: "7px 10px", fontFamily: "var(--font-mono)", fontSize: 11, color: roiColor(row.roi), fontWeight: 500 }}>
                      {fmtRoi(row.roi)}
                    </td>
                    {/* Trend arrow — сравнение с предыдущей строкой */}
                    <td style={{ padding: "7px 6px", textAlign: "center" }}>
                      <TrendArrow current={row.roi} previous={rows[idx - 1]?.roi} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
